export var JobProgressStepStatus;
(function (JobProgressStepStatus) {
    JobProgressStepStatus["JOB_PROGRESS_STEP_STATUS_UNSPECIFIED"] = "JOB_STEP_STATUS_UNSPECIFIED";
    JobProgressStepStatus["JOB_PROGRESS_STEP_STATUS_PENDING"] = "JOB_STEP_STATUS_PENDING";
    JobProgressStepStatus["JOB_PROGRESS_STEP_STATUS_RUNNING"] = "JOB_STEP_STATUS_RUNNING";
    JobProgressStepStatus["JOB_PROGRESS_STEP_STATUS_COMPLETED"] = "JOB_STEP_STATUS_COMPLETED";
    JobProgressStepStatus["JOB_PROGRESS_STEP_STATUS_FAILED"] = "JOB_STEP_STATUS_FAILED";
    JobProgressStepStatus["JOB_PROGRESS_STEP_STATUS_CANCELED"] = "JOB_STEP_STATUS_CANCELED";
    JobProgressStepStatus["JOB_PROGRESS_STEP_STATUS_SKIPPED"] = "JOB_STEP_STATUS_SKIPPED";
})(JobProgressStepStatus || (JobProgressStepStatus = {}));
